import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackUserCreatedParameters extends TrackEventBaseParameters<null, "has_approver" | "role"> {}

const trackUserCreated = (parameters: TrackUserCreatedParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "user_created", ...parameters }, options);
};

export default trackUserCreated;
